import { render } from "./KeyFact.vue?vue&type=template&id=5b818264&scoped=true"
import script from "./KeyFact.vue?vue&type=script&lang=js"
export * from "./KeyFact.vue?vue&type=script&lang=js"

import "./KeyFact.vue?vue&type=style&index=0&id=5b818264&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b818264"]])

export default __exports__